import { BrowserRouter } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ThemeProvider } from '@mui/material';
import Auth from 'components/Auth';
import 'theme/base.css';
import './App.css';
// import CookiesNotification from 'src/components/CookiesNotification';
// import GoogleAnalytics from 'src/components/GoogleAnalytics';
import ScrollReset from 'components/ScrollReset';
import theme from 'theme';
import Routes from './Routes'; //_Routes -> Para obtener todas las rutas del template
import { IntlProvider } from 'react-intl';
import locale from './utils/locale';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient()
function App() {
  return (
    <IntlProvider messages={locale} locale="es" defaultLocale="es">
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <SnackbarProvider maxSnack={4}>
              <BrowserRouter>
                <Auth>
                  <ScrollReset />
                  {/* <GoogleAnalytics /> */}
                  {/* <CookiesNotification /> */}
                  <Routes />
                </Auth>
              </BrowserRouter>
            </SnackbarProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </IntlProvider>
  );
}

export default App;
